import { Modal } from "../../Modal";
import fragmentsIcon from './icons/fragments50.png';
import { FC } from "react";
import { Button } from "../../../Buttons/Button/Button";
import styles from "./FragmentsDescriptionNotify.module.scss";

interface IFragmentsDescriptionNotifyProps {
    closeHandler: () => void;
}

export const FragmentsDescriptionNotify: FC<IFragmentsDescriptionNotifyProps> = ({ closeHandler }) => {
    const getContext = () => {
        return (
            <>
                <p>Фрагменты — это части сертификата Wildberries на 500 ₽.</p>
                <p>Соберите 50 фрагментов и получите сертификат!</p>
                <p className={styles.list}><b>Фрагменты можно получить:</b>
                    <div>1. За приглашение друзей.</div>
                    <div>2. За прохождение испытаний.</div>
                    <div>3. За участие в интерактивном розыгрыше.</div>
                    <div>4. За сбор легендарной коллекции.</div>
                    <div>5. За активность в игре.</div>
                </p>
            </>
        );
    }
    
    return (
        <Modal
            name='FragmentsDescriptionNotify'
            title='Зачем нужны фрагменты'
            message={ getContext() }
            icon={fragmentsIcon}
            button={ <Button caption='Закрыть' type='orange' handler={ () => closeHandler() } /> }
        />
    );
}